document.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname.includes('/collections/vendors')) {
    

    var vendorRedirects = {
      'kinto': '/collections/kinto',
      'corkcicle': '/collections/corkcicle',
      'anello': '/collections/anello',
      'yooletta': '/collections/yooletta',
      'oxo': '/collections/oxo',
      'chimi': '/collections/chimi',
      'mosh': '/collections/mosh',
      'contigo': '/collections/contigo',
      'izipizi': '/collections/izipizi',
      'tokyo': '/collections/tokyo',
      'lexon': '/collections/lexon',
      'umbra': '/collections/umbra',
      'hellolulu': '/collections/hellolulu',
      'keepcup': '/collections/keepcup',
      'arcosteel': '/collections/arcosteel',
      'mepal': '/collections/mepal'
      // דוגמה להוספת שורה נוספת:
      // 'brandname': '/collections/brandname'
    };

    var urlParams = new URLSearchParams(window.location.search);
    var vendorQuery = urlParams.get('q');

    function addNoIndex() {
      var meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, nofollow';
      document.head.appendChild(meta);
    }

    if (vendorQuery) {
      vendorQuery = vendorQuery.toLowerCase().trim();
      
      if (vendorRedirects[vendorQuery]) {
        var newUrl = vendorRedirects[vendorQuery];
        
        var link = document.createElement('link');
        link.rel = 'canonical';
        link.href = window.location.origin + newUrl;
        document.head.appendChild(link);
        
    
        window.location.replace(newUrl);
        
      } else {
        addNoIndex();
      }
    } else {
      addNoIndex();
    }
  }
});